import * as yup from 'yup'

export const connectionSchema = yup.object().shape({
  entityType: yup.string().required(),
  entityId: yup.string().required(),
})
